<template>
  <vz-button
    icon-name="printer"
    @click="getPrint"
  >
    <slot>Печать</slot>
  </vz-button>
</template>

<script setup lang="ts">
import {storeToRefs} from 'pinia';
import {useOrderStore} from '~/stores/order';
import {orderSaveCalc} from '@/api/order';
import {pricePayload} from '~/common/objects';
import VzButton from '~/components/ui-kit/vz-button.vue';

const { orderForm } = storeToRefs(useOrderStore())
const { $showToast } = useNuxtApp()

// From vz-order-container.vue
const createPdf: Function = inject('createPdf', () => {})

async function getPrint() {
  createPdf()
  return
  // const { origin, hash } = await orderSaveCalc(pricePayload(orderForm.value))
  // if (hash) {
  //   const link = `${origin}/order/create/?printOrder&calculation=${hash}&currency=${orderForm.value.currency}`
  //   window.open(link, '_blank')
  // } else {
  //   $showToast({
  //     title: 'Печать заказа',
  //     text: 'Проблема с получением данных',
  //     variant: 'error'
  //   })
  // }
}
</script>
